/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export enum ClientEventTypeDTO {
    viewed_memory_image = 'viewed_memory_image',
    shown_memory_notification = 'shown_memory_notification',
    viewed_collection_image = 'viewed_collection_image',
}
